import React, {lazy, Suspense, useEffect} from 'react'
import {connect} from 'react-redux'

import ConditionsPopup from './popups/ConditionsPopup'
import CvvInfoPopin from './popups/CvvInfoPopin'
import GlobalErrorPopUpSMSWENTWRNG from './popups/GlobalErrorPopUpSMSWENTWRNG'
import MultipleConfirmation from './popups/MultipleConfirmation'
import AppartmentOptionDetailsPopup from './popups/AppartmentOptionDetailsPopup'
import openPopup, {closePopup} from './actions/popupActions'
import {
  CONDITION_POPUP,
  CONDITION_POPUP_NEW,
  CVV_INFO_POPUP,
  GLOBAL_ERROR_POPUP,
  MULTIPLE_CONFIRMATION,
  GLOBAL_ERROR_POPUP_SMSWENTWRNG,
  APPARTMENT_OPTION_DETAILS,
  CLOSE_EVENT_KEY,
  FAMILY_POPUP,
  GALLERY_POPUP,
  LAST_CHANCE_POPUP,
  OPEN_EVENT_KEY,
  ROOM_POPUP,
  BREAKFAST_POPUP,
  PARKING_POPUP,
} from './constants'

import GlobalErrorPopUp from './popups/GlobalErrorPopUp';
import LastChancePopup from './popups/LastChancePopup';
import ConditionsPopupRedesign from './popups/ConditionsPopupRedesign';

const GalleryPopup = lazy(() => import("../../scenes/GalleryPopup"))
const FamilyPopup = lazy(() => import("./popups/FamilyFriendlyPopup"))
const RoomPopup = lazy(() => import("./popups/RoomPopup"));
const BreakfastPopup = lazy(() => import("./popups/BreakfastPopup"));
const ParkingPopup = lazy(() => import("./popups/ParkingPopup"));

const PopupConstructor = ({currentPopup, data, closePopupAction, openPopupAction}) => {
  const openModal = function (e) {
    const modalId = e?.detail?.id
    const modalOptions = e?.detail?.options

    if (modalId) {
      openPopupAction(modalId, modalOptions)
    }
  }

  const closeModal = function () {
    closePopupAction()
  }

  useEffect(() => {
    window.addEventListener(OPEN_EVENT_KEY, openModal)
    window.addEventListener(CLOSE_EVENT_KEY, closeModal)

    return function () {
      window.removeEventListener(OPEN_EVENT_KEY, openModal);
      window.removeEventListener(CLOSE_EVENT_KEY, closeModal);
    }
  }, [])

  switch (currentPopup) {
    case CONDITION_POPUP: return <ConditionsPopup />
    case CONDITION_POPUP_NEW: return <ConditionsPopupRedesign />
    case CVV_INFO_POPUP: return <CvvInfoPopin />
    case GLOBAL_ERROR_POPUP: return <GlobalErrorPopUp data={data} onClose={closePopupAction} />
    case LAST_CHANCE_POPUP: return <LastChancePopup data={data} onClose={closePopupAction} />
    case GLOBAL_ERROR_POPUP_SMSWENTWRNG: return <GlobalErrorPopUpSMSWENTWRNG />
    case MULTIPLE_CONFIRMATION: return <MultipleConfirmation data={data} />
    case APPARTMENT_OPTION_DETAILS: return <AppartmentOptionDetailsPopup data={data} />
    case GALLERY_POPUP: return (<Suspense><GalleryPopup id={data} /></Suspense>)
    case FAMILY_POPUP: return (<Suspense><FamilyPopup params={data}/></Suspense>)
    case ROOM_POPUP: return (<Suspense><RoomPopup data={data} onClose={closePopupAction} /></Suspense>)
    case BREAKFAST_POPUP: return (<Suspense><BreakfastPopup data={data} onClose={closePopupAction} /></Suspense>)
    case PARKING_POPUP: return (<Suspense><ParkingPopup data={data} onClose={closePopupAction} /></Suspense>)
    default: return null
  }
}

export const openReactModalEvent = function (id, options) {
  const event = new CustomEvent(OPEN_EVENT_KEY, {
    detail: {id, options}
  })
  window.top.dispatchEvent(event)
}

export const closeReactModalEvent = function () {
  const event = new CustomEvent(CLOSE_EVENT_KEY)
  window.top.dispatchEvent(event)
}

export default connect(
  ({popup: {currentPopup, data}}) => ({currentPopup, data}),
  {closePopupAction: closePopup, openPopupAction: openPopup}
)(PopupConstructor)
